
function embedScriptController($scope, $location, campaignManagerService, userService, accountsService, locationService, providerService) {
  let vm = this;
  vm.embedCode = false;
  vm.predefinedCampaignId = $scope.campaignId || false;
  vm.useLocationFilter = false;
  vm.useProviderFilter = false;
  vm.widgetConfig = {
    widgetId: $scope.widgetId
  };

  vm.showSummary = $scope.featureTags ? $scope.featureTags.indexOf('Summary') !== -1 : false;

  let embedRoute = `//${$location.host()}/reviewBuilder/widget/script`;
  vm.generateCode = function() {
    let params = _.mapObject(_.clone(vm.widgetConfig), val => Array.isArray(val) ? val.join(',') : val);
    _.mapObject(params, (val, key) => { if (val == null || val.length == 0) { delete params[key]; }}); // Filter empty criteria
    if (!params.providers || params.providers.indexOf("REVIEWBUILDER") === -1) {
      delete params.campaignId
    }
    if (vm.predefinedCampaignId) {
      params.campaignId = vm.predefinedCampaignId;
    }

    let queryString = $.param(params)

    let embedSrc = embedRoute + (queryString ? '?' + queryString : '')
    vm.embedCode = `<script type="text/javascript" id="${$scope.widgetId}" src="${embedSrc}"></script>`;
  };

  vm.validates = () => {
     return vm.showSummary ? vm.widgetConfig.formCampaignId : true
  }

  userService.currentUser().then(user => {

    vm.widgetConfig.accountId = user.accountId;  // this will need to be changed, I don't think resellers should be able to do stuff w/ their own account?

    if (user.permissions.indexOf("AccountManagement") !== -1) {
      // account switcher
      accountsService.listAccounts().then(accountsList => { vm.accounts = accountsList.accounts; })
    }

    $scope.$watch("vm.widgetConfig.accountId", function() {
      vm.widgetConfig.locationId = null;
      vm.widgetConfig.providers = [];
      getLocations().then(locations => {
        // For the sort, we don't really care about identical location names
        vm.locations = locations.map(location => locationService.formatLocation(location)).sort((a, b) => a.summary < b.summary ? -1 : 1);

        providerService.validProviders("account-" + vm.widgetConfig.accountId).then(providers => {
          vm.providers = providers.filter(x => x.providerSettings.shareableReviews);
        })

        if (!vm.predefinedCampaignId) {
          campaignManagerService.searchCampaigns({accountId: vm.widgetConfig.accountId, limit: 1000}).then(result => vm.campaigns = result.campaigns);
        }
      })
    })

    window.widgetConfig = vm.widgetConfig;
    $scope.$watch('vm.widgetConfig', function() {
      vm.generateCode();
    }, true)
  })

  $scope.clear = function($event) {
    $event.stopPropagation();
    vm.widgetConfig.locationId = null;
  }

  vm.generateCode();

  function getLocations() {
    console.log("Loading campaing group locations2: " + $scope.campaignGroupId)
    if ($scope.campaignGroupId != undefined && !$scope.campaignGroupId.startsWith("all-")) {
      return locationService.loadLocationGroup($scope.campaignGroupId)
    }
    else {
      return locationService.locationsForAccount(vm.widgetConfig.accountId)
    }
  }
}
embedScriptController.$inject = ['$scope', '$location', 'reviewGenService', 'userService', 'accountsService', 'locationService', 'providerService'];

module.exports = function(angularModule) {

  angularModule.directive('widgetEmbedScript', function() {
    return {
      template: require('./widgetEmbed.html'),
      controller: embedScriptController,
      controllerAs: 'vm',
      scope: {
        widgetId: '=widgetId',
        featureTags: '=',
        campaignId: '=campaignId',
        formCampaignId: '=formCampaignId',
        campaignGroupId: '=campaignGroupId'
      },
      restrict: 'E'
    }
  });

};


